import React from 'react';
import './WeWorkWith.css';
import CarRentalProcess from '../CarRentalProcess/CarRentalProcess';

const clients = [
  {
    number: '01',
    title: 'Govt Ministries',
    description: 'We provide reliable services to various ministries across the nation.',
  },
  {
    number: '02',
    title: 'Department & PSU',
    description: 'Working with public sector units to deliver top-notch solutions.',
  },
  {
    number: '03',
    title: 'General Suppliers',
    description: 'Trusted by general suppliers for consistent and dependable collaboration.',
  },
];

const WeWorkWith = () => {
  return (
    <>
    <section className="process-section">
      <div className="text-center">
        <p className="process-subtitle">PARTNERS</p>
        <h2 className="process-title fontgeorgio">
          We Work <span>With</span>
        </h2>
      </div>

      <div className="process-grid">
        {clients.map((client, index) => (
          <div 
            className="process-card" 
            key={index}
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay={`${index * 200}`}
          >
            <div className="process-content">
              <h3 className='fontgeorgio'>{client.title}</h3>
              <p className='fontroboto'>{client.description}</p>
            </div>
            <div className="process-number">
              {client.number}
            </div>
          </div>
        ))}
      </div>

      <div className="process-note">
        <span className="info-icon">i</span> We’re proud to serve institutions and vendors at every level.
      </div>
    </section>
    <CarRentalProcess />
    </>
  );
};

export default WeWorkWith;
